import React, { useState, useEffect, useMemo } from "react";
import { Button, useTheme, Box, IconButton, Stack, Dialog, DialogContent, DialogTitle, DialogActions, Tooltip, Typography } from "@mui/material";
import { tokens } from "../../assets/theme";
import { useQuery } from "@tanstack/react-query";
import { useLocalStorage } from "../../hooks/useLocalStorage";
//Components
import AxionControls from "../../components/controls/AxionControls";
import { pushErrorMessage } from "../../utils/notifications";
import AxionConfirmation from '../../components/controls/AxionConfirmation';
import Controls from "../../components/controls/Contols";
//Hooks

import { getDepartments, postDepartment, patchDepartment, deleteDepartment } from "../../fetchers/departments";
//Icons
import SaveIcon from '@mui/icons-material/Save';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
//Language
import messages from "./messages";
import { FormattedMessage, useIntl } from "react-intl";
import { event } from "jquery";

export default function EditDepartments(props) {

    const { formatMessage } = useIntl();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [companyKey, setCompanyKey] = useLocalStorage("companyKey", 1);

    const [newDepartment, setNewDepartment] = useState({ id: null, name: "", companyId: companyKey });
    const [newDimension, setNewDimension] = useState({ id: null, name: "", code: "", companyId: companyKey });
    const [showAddDepartment, setShowAddDepartment] = useState(true);
    const [openDepartment, toggleOpenDepartment] = React.useState(false);

    const [confirmationTitle, setConfirmationTitle] = useState("");
    const [confirmationMessage, setConfirmationMessage] = useState("");
    const [departmentId, setDepartmentId] = useState(null);
    const [openConfirmationDepartment, setOpenConfirmationDepartment] = useState(false);
    
    const departmentsQuery = useQuery(
        ["Departments", companyKey],
        () => getDepartments(companyKey),
        {}
    );

    const handleCloseDepartmentDialog = () => {
        setNewDimension({ id: null, name: "", code: "", companyId: companyKey });
        toggleOpenDepartment(false);
    };

    const handleDeleteDepartment = (id) => {
        setDepartmentId(id);
        setConfirmationTitle(formatMessage(messages.delete_department));
        setConfirmationMessage(formatMessage(messages.sure_delete_department));
        setOpenConfirmationDepartment(true);
    }

    const doDeleteDepartment = () => {
        setConfirmationTitle("");
        setConfirmationMessage("");
        setOpenConfirmationDepartment(false);

        deleteDepartment(departmentId).then(() => {
            departmentsQuery.refetch();
        }).catch((error) => {
            console.log(error);
            //setShowBackdrop(false);
            pushErrorMessage(formatMessage(messages.could_not_delete_department));
        })
    }

    const cancelDeleteDepartment = () => {
        setDepartmentId(null);
        setConfirmationTitle("");
        setConfirmationMessage("");
        setOpenConfirmationDepartment(false);
    }

    const handleAddDepartment = () => {
        console.log("new/edit Department", newDepartment);

        if (newDepartment.id !== null) {
            patchDepartment(newDepartment).then(() => {
                departmentsQuery.refetch();
                handleCloseDepartmentDialog();
            }).catch((error) => {
                console.log(error);
                //setShowBackdrop(false);
                pushErrorMessage(formatMessage(messages.could_not_update_department));
            });
        } else {
            postDepartment(newDepartment).then(() => {
                departmentsQuery.refetch();
                handleCloseDepartmentDialog();
            }).catch((error) => {
                console.log(error);
                //setShowBackdrop(false);
                pushErrorMessage(formatMessage(messages.could_not_create_department));
            });
        }
    }

    const handlePrepareAddDepartment = () => {

        toggleOpenDepartment(true);
        setShowAddDepartment(true);
        //setShowAddValue(false);
    }

    const handleNameChange = (event) => {
        let department = { ...newDepartment };
        department.name = event.target.value;
        setNewDepartment(department);
    }

    const handleEditDepartmentClick = (id) => {
        var dim = departmentsQuery.data?.filter(d => d.id === id);

        var tempDepartment = { ...newDepartment };
        tempDepartment.id = id;
        tempDepartment.name = dim[0].name;
        //tempDepartment.companyId = companyId;
        setNewDepartment(tempDepartment);
        toggleOpenDepartment(true);
    }

    return (
        <>
            <Box padding="30px"> </Box>
            <Box width="50%">
                <Box width="100%" justifyContent="flex-start" alignItems="center" display="flex" marginTop="10px" marginBottom="20px" marginLeft="15px">

                        <Controls.Button
                            onClick={handlePrepareAddDepartment}
                            text={formatMessage(messages.add_department)}
                            startIcon={<AddCircleOutlinedIcon />}
                            sx={{
                                "&:hover": {
                                    backgroundColor: colors.dashbordGreen[700],
                                },
                                backgroundColor: colors.dashbordGreen[500],
                                color: "#000000",
                            }}
                        />
                </Box>
                {/* {(dimensionsQuery?.data?.length > 0) && <Box marginTop="20px" color="#ffffff" marginLeft="10px">Dimensions and values</Box>} */}
                <Stack direction="column" width="100%" overflow="hidden" backgroundColor={colors.primary[300]} marginTop="5px" color="#ffffff" spacing="1px" marginLeft="15px">
                    <Box width="100%" alignItems="center" justifyContent="flex-start" display="flex" marginLeft="10px" backgroundColor={colors.primary[400]} padding="5px"><FormattedMessage {...messages.departments} /></Box>
                    {departmentsQuery?.data?.sort((a, b) => (a.name > b.name) ? 1 : -1).map((a) => {
                        return (
                            <>
                                <Stack direction="row" width="100%" backgroundColor={colors.primary[500]}>

                                    <Box width="70%" alignItems="center" justifyContent="flex-start" display="flex" marginLeft="10px" onClick={() => handleEditDepartmentClick(a.id)}>{a.name}</Box>
                                    <Box width="30%" justifyContent="flex-end" alignItems="center" display="flex">

                                        <Tooltip title={<Typography fontSize="12px"><FormattedMessage {...messages.edit_department} /> {a.name}</Typography>}>
                                            <IconButton onClick={() => { handleEditDepartmentClick(a.id) }}><EditOutlinedIcon /></IconButton>
                                        </Tooltip>
                                        <Tooltip title={<Typography fontSize="12px"><FormattedMessage {...messages.delete_department} /> {a.name}</Typography>}>
                                            <span>
                                                <IconButton onClick={() => { handleDeleteDepartment(a.id) }}><DeleteOutlinedIcon /></IconButton>
                                            </span>
                                        </Tooltip>
                                    </Box>
                                </Stack>
                            </>
                        )
                    })}
                    <Box padding="0px"> </Box>
                </Stack>
            </Box>

            <Dialog open={openDepartment} onClose={handleCloseDepartmentDialog} m={0} width="400px">
                <Box m={0} sx={{ backgroundColor: colors.primary[400], borderRadius: "4px" }} width="400px" >
                    {/* <form onSubmit={handleAddDimension}> */}
                    <DialogTitle>{(newDimension.id === null) ? <FormattedMessage {...messages.add_a_new_department} /> : <FormattedMessage {...messages.update_a_department} />}</DialogTitle>
                    <DialogContent>

                        <Stack direction="column" width="100%" overflow="hidden" >
                            <Box><AxionControls.AxionTextBox
                                label="Name" //{<FormattedMessage {...messages.timezone} />}
                                value={newDepartment.name}
                                autoComplete="new-password"
                                inputProps={{ autoComplete: 'new-password' }}
                                onChange={(event) =>
                                    handleNameChange(event)
                                }
                            /></Box>
                        </Stack>
                        <Stack direction="row" width="100%" overflow="hidden" marginTop="15px" display="flex" justifyContent="flex-end">
                            <Controls.Button
                                text="Close"
                                onClick={handleCloseDepartmentDialog}
                                // startIcon={<SaveIcon />}
                                sx={{
                                    "&:hover": {
                                        backgroundColor: "#535560",
                                    },
                                    backgroundColor: colors.primary[300],
                                    color: "#000000",

                                }}
                            />
                            <Controls.Button
                                marginLeft="10px"
                                text={(newDimension.id === null) ? <FormattedMessage {...messages.add_department} /> : <FormattedMessage {...messages.update_department} />}
                                onClick={handleAddDepartment}
                                startIcon={<SaveIcon />}
                                sx={{
                                    "&:hover": {
                                        backgroundColor: colors.dashbordGreen[700],
                                    },
                                    backgroundColor: colors.dashbordGreen[500],
                                    color: "#000000",
                                    marginLeft: "10px"
                                }}
                            />
                        </Stack>
                    </DialogContent>
                </Box>
            </Dialog>


          <AxionConfirmation open={openConfirmationDepartment} title={confirmationTitle} message={confirmationMessage} onConfirm={doDeleteDepartment} onCancel={cancelDeleteDepartment} cancelText={formatMessage(messages.no)} confirmText={formatMessage(messages.yes)} />
             {/*  <AxionConfirmation open={openConfirmationValue} title={confirmationTitle} message={confirmationMessage} onConfirm={doDeleteDimensionValue} onCancel={cancelDeleteDimensionValue} cancelText={formatMessage(messages.no)} confirmText={formatMessage(messages.yes)} /> */}



        </>

    )

}